import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { RoleService } from '../../shareModule/services/roles/role.service';
import { SharedService } from '../../shareModule/services/shared.service';
import { ModalService } from '../../shareModule/services/modal.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { CompareProductListComponent } from '../compare-product-list/compare-product-list.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { Subscription, Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { EditTypesComponent } from '../../edit-types/edit-types.component';

@Component({
  selector: 'app-product-types-list',
  templateUrl: './product-types-list.component.html',
  styleUrl: './product-types-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTypesListComponent implements OnChanges, OnInit, OnDestroy {
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private roleService: RoleService,
    private sharedService: SharedService,
    private seoService: SeoService,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private cdr: ChangeDetectorRef,
    @Inject('WINDOW') private window: any,
    private commonService: CommonService
  ) { }
  private destroy$ = new Subject<void>();
  carouselWithNavOptions2: any = {
    spaceBetween: 8,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
    grid: {
      rows: 2,
      fill: 'row',
    },
  };
  ngOnDestroy(): void {
    this._roleSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private _roleSubscription: Subscription | null = null;
  backgroundColor = 'var(--primary)';
  ngOnInit(): void {
    //this._fetchTypesOfProduct();
    this._roleSubscription = this.roleService.rolesSubject.subscribe(() => {
      this.isUserAnAdmin = this.roleService?.roles?.userType.includes('ADMIN');
      this.cdr.detectChanges();
    });

    this.commonService.mapCustomizationObserver.pipe(takeUntil(this.destroy$)).subscribe((customization) => {
      this.backgroundColor = customization?.faqQuestionFieldColor ?? 'var(--primary)';
      this.cdr.detectChanges();
    });
  }
  ////////////////code related to editing category for admin ///////////////////////////
  @ViewChild('editCategory')
  editCategory: TemplateRef<any>;

  public nameOfCurrentCategory = '';
  public newCategoryName = '';
  public typeOneNaming = '';
  public typeTwoNaming = '';
  public newType = '';
  public newTypeGroup = 1;
  public currentOpenModalRef?: NgbModalRef | null = null;

  public showEditCategoryModal() {
    this.typeOneNaming = this.typeGroupingCustomNamesMap[1] ?? 'Categories';
    this.typeTwoNaming = this.typeGroupingCustomNamesMap[2] ?? 'Services';
    this.newCategoryName = this.nameOfCurrentCategory;

    this.currentOpenModalRef = this.modalService.open(EditTypesComponent, {
      size: 'md',
      backdrop: 'static',
    });

    const componentInstance = this.currentOpenModalRef.componentInstance as EditTypesComponent;
    componentInstance.categoryId = this.categoryId;
    componentInstance.typeOneNaming = this.typeOneNaming;
    componentInstance.typeTwoNaming = this.typeTwoNaming;
    componentInstance.nameOfCurrentCategory = this.nameOfCurrentCategory;
    componentInstance.currentProductCategoryAvailableTypes = this.currentProductCategoryAvailableTypes;

    this.currentOpenModalRef?.hidden
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this._fetchTypesOfProduct());
  }

  public closeCurrentOpenModal() {
    this.currentOpenModalRef?.close();
  }
  public saveCategoryInfo() {
    if (this.newCategoryName != this.nameOfCurrentCategory) {
      this.auth
        .updateMemberCategoryInfo({
          name: this.newCategoryName,
          id: this.categoryId,
        })
        .subscribe({
          next: () => {
            this.toastr.info(`Category name updated`);
          },
          error: (err) => {
            console.error(err);
            this.toastr.error(
              `Error while chaning categrory name to ${this.nameOfCurrentCategory}`
            );
          },
        });
    }

    const vals = [
      [
        1,
        this.typeOneNaming,
        this.typeOneNaming != this.typeGroupingCustomNamesMap[1],
      ],
      [
        2,
        this.typeTwoNaming,
        this.typeTwoNaming != this.typeGroupingCustomNamesMap[2],
      ],
    ];
    for (const [number, naming, cond] of vals) {
      if (cond) {
        this.auth
          .setTypeGroupingName(number, naming, this.categoryId)
          .subscribe({
            next: () => {
              this.toastr.info(`group ${number}'s name changed to ${naming}`);
            },
            error: (err) => {
              console.error(err);
              this.toastr.error(
                `Error while chaning group ${number}'s name changed to ${naming}`
              );
            },
          });
      }
    }
  }

  /******************************************* Sub type  ***********************************/
  public newSubType = '';
  public addNewSubType() {
    this.auth
      .createSubType(this.newSubType, this.selectedTypeToEdit?.id)
      .subscribe({
        next: () => {
          this._fetchSubTypeOfCurrentlySelectedType();
          this.newSubType = '';
          this.toastr.success('Added!');
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong while adding a subtype');
        },
      });
  }
  public subTypesOfSelectedType = [];
  public removeSubTypeFromAfterConfirmation(event, subType) {
    event.stopPropagation();
    this.local
      .confirmYesNo({
        title: 'Are you sure you want to remove subtype',
        text: 'Are you sure you want to remove subtype',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.deleteSubType(subType.id).subscribe({
            next: () => {
              this._fetchSubTypeOfCurrentlySelectedType();
            },
            error: (err) => {
              console.error(err);
              this.toastr.error('Something went wrong while removing type');
            },
          });
        }
      });
  }
  private _fetchSubTypeOfCurrentlySelectedType() {
    this.auth.getSubTypesOfType(this.selectedTypeToEdit?.id).subscribe({
      next: (data: any) => {
        this.subTypesOfSelectedType = data.data;
      },
      error: console.error,
    });
  }

  public selectTypeToEdit(type) {
    this.selectedTypeToEdit = type;
    this._fetchSubTypeOfCurrentlySelectedType();
  }
  public addNewType() {
    this.auth
      .createSubCategoryType(this.newType, this.newTypeGroup, this.categoryId)
      .subscribe({
        next: () => {
          this.toastr.success('Added!');
          this.newType = '';
          this._fetchTypesOfProduct();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong while adding a type');
        },
      });
  }

  public removeTypeFromAfterConfirmation(event, type) {
    event.stopPropagation();
    this.local
      .confirmYesNo({
        title: 'Are you sure you want to remove type',
        text: 'Are you sure you want to remove type',
        icon: 'warning',
      })
      .then((res) => {
        if (res.isConfirmed) {
          this.auth.deleteSubCategoryType(type.id).subscribe({
            next: () => {
              this._fetchTypesOfProduct();
              this.toastr.success('Type removed from product');
            },
            error: (err) => {
              console.error(err);
              this.toastr.error('Something went wrong while removing type');
            },
          });
        }
      });
  }

  public get isOnCategoryPage(): boolean {
    //since this component can also be used on product page
    return (
      this.sharedService.isBrowser() &&
      this.window.location.href.includes('/category/')
    );
  }

  ///////////////////////////////////////////////////////////////////////////////////

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['productId'] ||
      changes['categoryId'] ||
      changes['showAllTypes']
    ) {
      this._fetchTypesOfProduct();
      if (changes['categoryId']) {
        const prevCategoryId = changes['categoryId'].previousValue;
        const currCategoryId = changes['categoryId'].currentValue;
        const firstCategoryId = changes['categoryId'].firstChange;

        if (prevCategoryId != currCategoryId && firstCategoryId) {
          this._fetchTypesOfProduct();
        }
      }
    }
    if (changes['selectedTypeOneData'] || changes['selectedTypeTwoData']) {
      console.log(this.selectedTypeOneData, this.selectedTypeOneData);
      this.cdr.detectChanges();
    }
  }

  @Input()
  editable: boolean = true;

  @Input()
  productId: any;

  @Input({ required: true })
  categoryId: any;

  @Input()
  showAllTypes: boolean = false;

  @Input()
  showViaPopup: boolean = true;

  @Input()
  viewDesignScroll: boolean = false;

  @Input()
  isSelectSubCat: boolean = false;

  @Output()
  public typesExist = new EventEmitter();

  @Output()
  public typeList = new EventEmitter();

  @Output()
  public selectedType = new EventEmitter();

  public getBottomTabInfo(pd) {
    if (!pd) {
      return [];
    }
    return [
      {
        title: 'Experiences',
        condition: pd?.xpCount > 0,
      },
      {
        title: 'Discuss',
        condition: pd?.forum,
      },
    ];
  }

  public selectedTypeToEdit = null;

  @ViewChild('seeProductList')
  public seeProductList: TemplateRef<any>;

  public searchUsingTypes(type) {
    this.auth.getSubTypesOfType(type?.id).subscribe({
      next: (data: any) => {
        this.typeList.emit(data.data);
      },
      error: console.error,
    });
    const typeList = [];
    this.selectedTypeOneData, this.selectedTypeTwoData;

    if (this.selectedTypeOneData) {
      typeList.push(this.selectedTypeOneData);
    }
    if (this.selectedTypeTwoData) {
      typeList.push(this.selectedTypeTwoData);
    }
    console.log('selected types', typeList);
    // if (this.showViaPopup && this.typeList.length) {
    //   this.auth
    //     .fetchProductsBasedOnTypes({ types: Array.from(typeList) })
    //     .subscribe({
    //       next: (data: any) => {
    //         this.searchProds = data.data;
    //         this.modalService.open(this.seeProductList, { size: 'md' });
    //       },
    //       error: (err) => {
    //         console.error(err);
    //         this.toastr.error('Error something went wrong while fetching ');
    //       },
    //     });

    // }
    // else{
    //   this.searchProds = [];
    // }
    this.selectedType.emit(typeList);
  }

  @Input()
  public selectedTypeOneData = null;

  @Input()
  public selectedTypeTwoData = null;

  /**
   * This contains the cusom names type groupings are given
   * so type 1 could be anything named in the backend side
   */
  public typeGroupingCustomNamesMap = new Map<number, string>();
  private _fetchTypesOfProduct() {
    if (!this.categoryId) {
      return;
    }

    //////console.log("Fetching productTypes")
    if (this.categoryId && this.categoryId != -1) {
      this.auth.getTypesOfCategory(this.categoryId).subscribe({
        next: (data: any) => {
          this.currentProductCategoryAvailableTypes = data.data;
          console.log(this.currentProductCategoryAvailableTypes, "currentProductCategoryAvailableTypes")
          this.typesChanged.emit(this.currentProductCategoryAvailableTypes);

          this.seoService.updateKeywords(
            this.currentProductCategoryAvailableTypes
              .map((row) => row.name)
              .join(', ')
          );
          if (!this.productId) {
            //if productId doesnt exist we are on productPage
            const emitVal = this.typeOneExists || this.typeTwoExists;
            ////console.log('categoyId', {emitVal})
            this.typesExist.emit(emitVal);
          }
          this.cdr.detectChanges();
          //console.log('here 1', this.currentProductCategoryAvailableTypes)
        },
      });
    }

    if (this.productId) {
      this.auth.getTypesOfProduct(this.productId).subscribe({
        next: (data: any) => {
          this.productTypes = new Set(data.data.map((t) => t.typeId));
          this.currentProductCategoryAvailableTypes = data.others;
          this.seoService.updateKeywords(
            this.currentProductCategoryAvailableTypes
              .map((row) => row.name)
              .join(', ')
          );
          const emitVal = this.typeOneExists || this.typeTwoExists;
          ////console.log('product side', {emitVal})
          this.typesExist.emit(emitVal);
          //console.log('here 2', this.currentProductCategoryAvailableTypes)
        },
        error: console.error,
      });
    }

    if (this.categoryId) {
      this.auth.getTypeGroupingNamesOfSubCategory(this.categoryId).subscribe({
        next: (data: any) => {
          for (const entry of data.data) {
            this.typeGroupingCustomNamesMap[entry.typeNumber] = entry.typeName;
          }
          this.nameOfCurrentCategory = data.nameOfCategory;
          //console.log('here 3', this.currentProductCategoryAvailableTypes)
        },
        error: console.error,
      });
    }
  }

  public get isOnMobile() {
    if (this.sharedService.isBrowser()) {
      return this.window.innerWidth <= 767;
    }
    return 0;
  }

  public handleTypeAssignment(event, item) {
    let subs;
    const target = event.target;
    if (target.checked) {
      subs = this.auth.addTypeToProduct(this.productId, item.id);
    } else {
      subs = this.auth.removeTypeFromProduct(this.productId, item.id);
    }
    subs.subscribe({
      next: () => this.toastr.success('Changed'),
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong while changed');
      },
    });
  }

  public isUserAnAdmin = false;

  public get typeOneExists() {
    return this.currentProductCategoryAvailableTypes.some(
      (t) =>
        t.type == 1 &&
        (this.productTypes.has(t.id) || this.isUserAnAdmin || this.showAllTypes)
    );
  }
  public get typeTwoExists() {
    return this.currentProductCategoryAvailableTypes.some(
      (t) =>
        t.type == 2 &&
        (this.productTypes.has(t.id) || this.isUserAnAdmin || this.showAllTypes)
    );
  }

  public goToProduct(prod) {
    this.window.open('product/' + prod.slug, '_blank');
  }
  public productTypes = new Set();
  public currentProductCategoryAvailableTypes = []; //all the types in the category
  @Output() typesChanged = new EventEmitter<any[]>();

  // public selectedTypeIds = new Set();

  public toggleType(type) {
    // if (this.selectedTypeIds.has(type.id)) {
    //   this.selectedTypeIds.delete(type.id);
    // } else {
    //   this.selectedTypeIds.add(type.id);
    // }
    if (type.type == 1) {
      if (this.selectedTypeOneData?.id == type?.id) {
        this.selectedTypeOneData = null;
      } else {
        this.selectedTypeOneData = type;
      }
    } else if (type.type == 2) {
      if (this.selectedTypeTwoData?.id == type?.id) {
        this.selectedTypeTwoData = null;
      } else {
        this.selectedTypeTwoData = type;
      }
    } else {
      console.error('unknown type!');
    }
    this.searchUsingTypes(type);
  }
  public searchProds = [];
}
